// import { TareaModel, TaskDocModel } from '../models/TaskModel';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { NoteCollaboratorModel } from '../../collaborators/models/CollaboratorModel';
import {
  getNoteTaskByID,
  updateNoteTask,
} from '../../../service/bitacora/Bitacora';
import { NoteTaskModel } from '../../bitacora/tareas/models/NoteTaskModel';

export const useGetNoteTaskByID = (id: string, reload: number) => {
  const note: NoteTaskModel = {
    id: 0,
    nombre: '',
    descripcion: '',
    origen: 'W',
  };
  const [noteInit, setNoteInit] = useState<NoteTaskModel>(note);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getNoteTaskByID(id)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setNoteInit(res);
      }
    };
    if (id) {
      fetchPost();
    } else {
      setNoteInit(note);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, reload]);

  return { noteInit };
};

export const useEditNoteTask = () => {
  const [loadingEditNote, setLoadingEditNote] = useState<boolean>(false);
  const history = useHistory();
  const editNote = async (note: NoteTaskModel) => {
    setLoadingEditNote(false);
    try {
      await updateNoteTask(note);
      setLoadingEditNote(true);
    } catch (error) {
      history.push('/error/500');
      setLoadingEditNote(false);
    }
  };
  return { editNote, loadingEditNote };
};
